import React from "react";
//
//component
import DraggerAudio from "component/upload/upload_audio";
//redux
//selector
//actions
//utils
//hook
import { FLOWS, useUploadFlow } from "hook/bailiff/document/flow/useUploadFlow";
import { useDispatch } from "react-redux";
import { previewStep } from "store/bailiff/bailiff/document/bailiff_document.action";

//str
const UploadAudio = ({ setAudio }) => {
  // -------------------------- VAR -----------------------------
  const { flow } = useUploadFlow();
  const isUpload = flow === FLOWS.UPLOAD;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const onUpload = async (action) => {
    const file = action?.file;
    const fileName = file?.name;
    const audio = { file, fileName };
    setAudio(audio);
    dispatch(previewStep());
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isUpload) return null;
  return <DraggerAudio onUpload={onUpload} />;
};
export default UploadAudio;
